import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {SIZES, Image} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import {convertToRoman} from 'app/helpers/convertToRoman';
import {StyledTypography} from 'app/styles/content';

const Row = styled.div`
  display: flex;
  flex: 0 100%;
  margin-bottom: ${SIZES['8']};
  justify-content: center;
  align-items: center;
  align-content: center;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  padding-left: ${SIZES['16']};
`;

const ImageContainer = styled.div`
  display: flex;
  // Aspect Ratio 16:9
  width: 40vw;
  height: 22.5vw;
  ${props => props.theme.desktopLayout`
      max-width: ${props => props.theme.desktopContentWidth * 0.4}px;
      max-height: ${props => (props.theme.desktopContentWidth * 0.4 * 9) / 16}px;
    `}
`;

const TeamBlock = ({team}) => {
  const teamNameLevel =
    team.ageGroup.slug === 'mr' || team.level === 1
      ? team.ageGroup.name
      : team.ageGroup.name + ' ' + convertToRoman(team.level);

  const teamName = !team.competition.active ? `${teamNameLevel} - Archiv` : teamNameLevel;

  const competitionName = !team.competition.active
    ? `${team.competition.middleName} ${team.competition.season.name}`
    : team.competition.middleName;

  return (
    <LinkOnComponent to={`/team/${team.slug}`}>
      <Row>
        <ImageContainer>
          <Image entity='team-image' actualWidthFactor={2.5} ratio='16:9' src={team.teamImage} />
        </ImageContainer>
        <InnerContainer>
          <StyledTypography variant='body1' lineHeight={20}>
            {teamName}
          </StyledTypography>
          <StyledTypography variant='body2' lineHeight={20}>
            {competitionName}
          </StyledTypography>
        </InnerContainer>
      </Row>
    </LinkOnComponent>
  );
};

TeamBlock.propTypes = {
  team: PropTypes.object.isRequired,
};

export default TeamBlock;
